/* LOV: outbound shipping estimate in Essential Cart Drawer. Shopify checkout is authoritative. */
(() => {
  const rowSelector = '[data-lov-shipping-line]';
  const footerSelector = '[data-essential-cart-element="cart-drawer-footer"]';
  let lastRow = null;
  let lastSubtotal = '';
  let pending = null;
  let requestId = 0;

  function render() {
    const dialog = document.querySelector('[role="dialog"][data-preview="false"]');
    const row = dialog?.querySelector(rowSelector);
    if (!row) {
      lastRow = null;
      lastSubtotal = '';
      return;
    }

    const subtotal = dialog.querySelector('[data-essential-cart-element="subtotal-wrapper"]')?.textContent?.trim() || '';
    if (row === lastRow && subtotal === lastSubtotal) return;
    lastRow = row;
    lastSubtotal = subtotal;
    const currentRequest = ++requestId;

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then((cart) => {
        if (currentRequest !== requestId || !row.isConnected) return;
        const itemCount = Number(cart.item_count);
        const totalCents = Number(cart.total_price);
        if (!itemCount || !Number.isFinite(totalCents)) {
          row.style.display = 'none';
          return;
        }
        const value = row.querySelector('[data-lov-shipping-value]');
        if (value) value.textContent = totalCents >= 10000 ? 'Kostenlos' : '+ 4,90 €';
        row.style.display = 'flex';
      })
      .catch(() => {
        if (currentRequest === requestId && row.isConnected) row.style.display = 'none';
      });
  }

  function schedule() {
    if (pending !== null) clearTimeout(pending);
    pending = setTimeout(() => {
      pending = null;
      render();
    }, 60);
  }

  const observer = new MutationObserver((changes) => {
    if (changes.some((change) => {
      const target = change.target.nodeType === Node.ELEMENT_NODE ? change.target : change.target.parentElement;
      if (target?.closest?.(footerSelector)) return true;
      return [...change.addedNodes].some((node) =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches?.(rowSelector) || node.querySelector?.(rowSelector))
      );
    })) schedule();
  });
  observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();